import { Injectable } from "@angular/core";

import { CarouselData } from "@core/models/carousel-data";
import { Observable, Subject } from "rxjs";

@Injectable()
export class PhotoService {

	public photoCarousel: CarouselData[];

	private photoAddedSubject = new Subject<CarouselData>();
	private photoEditedSubject = new Subject<CarouselData>();
	private photoDeletedSubject = new Subject<any>();

	constructor() {

		this.photoCarousel = new Array<CarouselData>();
	}

	public onPhotoAdded(): Observable<CarouselData> {

		return this.photoAddedSubject.asObservable();
	}

	public onPhotoEdited(): Observable<CarouselData> {

		return this.photoEditedSubject.asObservable();
	}

	public onPhotoDeleted(): Observable<any> {

		return this.photoDeletedSubject.asObservable();
	}

	getPhotos(): CarouselData[] {

		return this.photoCarousel;
	}

	addPhoto(carouselData: CarouselData) {

		this.photoCarousel.unshift(carouselData);
		this.photoAddedSubject.next(carouselData);
	}

	editPhoto(carouselData: CarouselData) {

		const photoIndex = this.photoCarousel.findIndex(x => x.id === carouselData.id);

		if (photoIndex >= 0) {

			this.photoCarousel[photoIndex] = carouselData;
			this.photoEditedSubject.next(carouselData);
		}
	}

	deletePhoto(carouselId: any) {

		const photoIndex = this.photoCarousel.findIndex(x => x.id == carouselId);
		if (photoIndex != -1) {

			this.photoCarousel.splice(photoIndex, 1);
			this.photoDeletedSubject.next(carouselId);
		}
	}
}